import Vue from "vue";
import VueRouter from "vue-router";
import vuex from "../store";
import { AUTHORITIES } from "@/utils/authorities";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    alias: "*",
    name: "Login",
    component: () => import("@/views/Login.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: false,
    },
  },
  {
    path: "/:locale/login",
    alias: "/login",
    name: "LangLogin",
    props: true,
    component: () => import("@/views/Login.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: false,
    },
  },
  {
    path: "/registration/:initialConfigPublicId?",
    name: "Registration",
    props: true,
    component: () => import("@/views/Registration.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: false,
    },
  },
  {
    path: "/:locale/registration/:initialConfigPublicId?",
    alias: "/registration/:initialConfigPublicId?",
    name: "LangRegistration",
    props: true,
    component: () => import("@/views/Registration.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: false,
    },
  },
  {
    path: "/second-factor",
    name: "SecondFactor",
    component: () => import("@/views/SecondFactor.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: false,
    },
  },
  {
    path: "/application-check",
    name: "ApplicationCheck",
    component: () => import("@/views/ApplicationCheck.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: true,
    },
  },
  {
    path: "/application",
    name: "Application",
    component: () => import("@/views/Application.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: true,
    },
  },
  {
    path: "/application-failed",
    name: "ApplicationFailed",
    component: () => import("@/views/ApplicationFailed.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: true,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("@/views/Profile.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
    },
  },
  {
    path: "/keys",
    name: "ApiKeys",
    component: () => import("@/views/ApiKeys.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.API_KEY.LIST, AUTHORITIES.API_KEY.ADMIN],
    },
  },
  {
    path: "/purchases",
    name: "Purchases",
    component: () => import("@/views/Purchases.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.LIST, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/purchase/:id",
    name: "Purchase",
    props: true,
    component: () => import("@/views/Purchase.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.GET, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/deal/:given",
    name: "Deal",
    props: true,
    component: () => import("@/views/Deal.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.GET, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/bnpl-applications",
    name: "BnplApplications",
    component: () => import("@/views/BnplApplications.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [
        AUTHORITIES.BNPL.APPLICATION.LIST,
        AUTHORITIES.BNPL.APPLICATION.ADMIN,
      ],
    },
  },
  {
    path: "/bnpl-application/:given",
    name: "BnplApplication",
    props: true,
    component: () => import("@/views/BnplApplication.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [
        AUTHORITIES.BNPL.APPLICATION.GET,
        AUTHORITIES.BNPL.APPLICATION.ADMIN,
      ],
    },
  },
  {
    path: "/bnpl-b2b-applications",
    name: "BnplB2bApplications",
    component: () => import("@/views/BnplB2bApplications.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [
        AUTHORITIES.BNPL.APPLICATION.LIST,
        AUTHORITIES.BNPL.APPLICATION.ADMIN,
      ],
    },
  },
  {
    path: "/bnpl-b2b-applications/create",
    name: "NewB2bApplication",
    component: () => import("@/views/NewB2bApplication.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.GET, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/bnpl-b2b-applications/:id",
    name: "BnplB2bApplication",
    props: true,
    component: () => import("@/views/BnplB2bApplication.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [
        AUTHORITIES.BNPL.APPLICATION.GET,
        AUTHORITIES.BNPL.APPLICATION.ADMIN,
      ],
    },
  },
  {
    path: "/bnpl-prescores",
    name: "BnplPrescores",
    component: () => import("@/views/BnplPrescores.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [
        AUTHORITIES.BNPL.APPLICATION.LIST,
        AUTHORITIES.BNPL.APPLICATION.ADMIN,
      ],
    },
  },
  {
    path: "/bnpl-prescore/:given",
    name: "BnplPrescore",
    props: true,
    component: () => import("@/views/BnplPrescore.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [
        AUTHORITIES.BNPL.APPLICATION.GET,
        AUTHORITIES.BNPL.APPLICATION.ADMIN,
      ],
    },
  },
  {
    path: "/deal",
    name: "NewApplication",
    component: () => import("@/views/NewApplication.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.GET, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/deals",
    name: "Deals",
    component: () => import("@/views/Deals.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.LIST, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/limits",
    name: "LimitList",
    component: () => import("@/views/Limits.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.LIST, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/limit/:id",
    name: "Limit",
    props: true,
    component: () => import("@/views/Limit.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.LIST, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/customer-limits",
    name: "CustomerLimits",
    component: () => import("@/views/CustomerLimits.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.LIST, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/customer-limits/:limitId",
    name: "CustomerLimit",
    component: () => import("@/views/CustomerLimit.vue"),
    props: true,
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.PURCHASE.LIST, AUTHORITIES.PURCHASE.ADMIN],
    },
  },
  {
    path: "/reset-password",
    name: "PasswordReset",
    props: true,
    component: () => import("@/views/PasswordReset.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: false,
    },
  },
  {
    path: "/users",
    name: "Users",
    component: () => import("@/views/Users.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.USER.LIST, AUTHORITIES.USER.ADMIN],
    },
  },
  {
    path: "/user/:id?",
    name: "User",
    props: true,
    component: () => import("@/views/User.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.USER.GET, AUTHORITIES.USER.ADMIN],
    },
  },
  {
    path: "/activate-user",
    name: "ActivateUser",
    props: true,
    component: () => import("@/views/ActivateUser.vue"),
    meta: {
      layout: "AppRegistrationLayout",
      protected: false,
    },
  },
  {
    path: "/applications",
    name: "Applications",
    component: () => import("@/views/Applications.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [
        AUTHORITIES.APPLICATION.LIST,
        AUTHORITIES.APPLICATION.ADMIN,
      ],
    },
  },
  {
    path: "/application-details/:id",
    name: "ApplicationDetails",
    props: true,
    component: () => import("@/views/ApplicationDetails.vue"),
    meta: {
      layout: "AppLoggedInLayout",
      protected: true,
      authorities: [AUTHORITIES.APPLICATION.GET, AUTHORITIES.APPLICATION.ADMIN],
    },
  },
  {
    path: "/bnpl-deal/:given",
    name: "BnplDeal",
    props: true,
    component: () => import("@/views/Deal.vue"),
    meta: {
      protected: true,
      authorities: [AUTHORITIES.APPLICATION.GET, AUTHORITIES.APPLICATION.ADMIN],
    },
  },
  {
    path: "/bnpl-deals",
    name: "BnplDealList",
    component: () => import("@/views/Deals.vue"),
    meta: {
      protected: true,
      authorities: [AUTHORITIES.APPLICATION.GET, AUTHORITIES.APPLICATION.ADMIN],
    },
  },
  {
    path: "/delayed-transactions",
    name: "DelayedTransactions",
    component: () => import("@/views/DelayedTransactions.vue"),
    meta: {
      protected: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  console.debug("Routing to " + to.name);
  let isLoggedIn = vuex.getters["session/isReady"];
  if (to.meta.protected === false) {
    if (!isLoggedIn) {
      next();
    } else {
      next({ path: "/application" });
    }
  } else {
    if (isLoggedIn) {
      if (
        !to.meta.authorities ||
        vuex.getters["session/hasAnyAuthority"](to.meta.authorities)
      ) {
        next();
      } else {
        next(false);
      }
    } else {
      next({ path: "/login" });
    }
  }
});

export default router;
